import {App as AntdApp} from "antd";
import className from "classnames/bind";
import {Button, FontAwesomeIcon} from "~/components";
import style from "../style/SchemaTool.module.scss";

const cn = className.bind(style);

/**
 * Hiển thị JSON-LD đã sinh + nút Copy. `wrapScript` (mặc định true) bọc trong thẻ
 * <script type="application/ld+json"> để dán thẳng vào <head>.
 */
function JsonLdOutput({json, wrapScript = true, actions}) {

	const {message} = AntdApp.useApp();

	const jsonText = JSON.stringify(json, null, 2);

	const fullText = wrapScript
		? `<script type="application/ld+json">\n${jsonText}\n</script>`
		: jsonText;

	const copy = async () => {
		try {
			await navigator.clipboard.writeText(fullText);
			message.success('Đã sao chép');
		} catch (e) {
			message.error('Không sao chép được');
		}
	};

	return (
		<div className={cn('output')}>
			<div className={cn('output-head')}>
				<span><FontAwesomeIcon icon="fa-light fa-code" /> JSON-LD</span>
				<div className={cn('output-actions')}>
					{actions}
					<Button small blue onClick={copy}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-copy" />}>
						Copy
					</Button>
				</div>
			</div>
			<pre className={cn('output-pre')}>{fullText}</pre>
		</div>
	);
}

export default JsonLdOutput;
